<template>
  <div>
    <Breadcrumbs :title="pageTitle" />

    <div class="container-fluid">

      <Loading v-if="loading" style="height: 800px" />

      <div class="row" v-else>
        <div class="col-sm-12 col-lg-6 col-xl-4 xl-50 col-md-12">
          <div class="card height-equal">
            <div class="calender-widget">
              <div class="cal-img">
                <img v-if="goal_data.coverImageUrl" :src="goal_data.coverImageUrl" alt="" @error="imageLoadError(goal_data.id)">
                <img v-else src="../../assets/images/default-img.jpg" class="img-fluid sm-100-w" alt="">
              </div>
              <div class="cal-date" v-html="moment(goal_data.createdAt)"></div>
              <div class="cal-desc text-center card-body">
                <h6 class="f-w-600">
                  {{goal_data.title}}
                </h6>
                <p class="text-muted mt-3 mb-0">
                  {{goal_data.fullDescription}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-lg-6 col-xl-8 xl-50 col-md-12">
          <div class="card bg-primary" v-if="getOneGoal()">
            <div class="card-body">
              <div class="media faq-widgets">
                <div class="media-body">
                  <h5>{{getOneGoal().title}}</h5>
                  <p>{{getOneGoal().description}}</p>
                </div>

                <i data-v-07452373="" data-name="book-open" data-tags="read,library" data-type="book-open"
                   class="feather feather--book-open">
                  <svg data-v-07452373="" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                       fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                       class="feather feather-book-open feather__content">
                    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
                    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
                  </svg>
                </i>
              </div>
            </div>
          </div>

          <div v-else>
            <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert alert-primary outline alert-primary">
              There are no goal yet
            </div>
          </div>

          <div v-if="getOneGoal()">
            <UserMilestones :user_milestones="getOneGoal().milestones" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Breadcrumbs from "../../components/bread_crumbs";
  import Loading from "../../components/loading";
  import moment from "moment";
  import UserMilestones from "./user-milestones"

  export default {
    name: "user-trac-details",
    components: {
      UserMilestones,
      Breadcrumbs,
      Loading
    },
    data() {
      return {
        goal_data: [],
        loading: true,
        pageTitle: ""
      }
    },
    methods: {
      init() {
        this.loading = true;
        var tracId = this.$route.params.tracId;
        var clientId = this.$route.params.clientId;

        if (tracId) {
          this.$store.dispatch("getUserTracById", { tracId, clientId } ).then(() => {
            this.goal_data = this.$store.state.goal;
            this.loading = false;
          }).catch(() => this.loading = false);
        }

        if (clientId) {
          this.$store.dispatch('getReferralsById', clientId).then((val) => {
            var clientData = val.data.result;
            this.pageTitle = `${clientData.firstName} ${clientData.lastName}'s SMARTracs`
          });
        }
      },
      moment(date) {
        return `<h5>${moment(date).format('D')}<br>${moment(date).format('MMM')}</h5>`
      },
      imageLoadError(id) {
        if (this.goal_data.details.uid === id) {
          this.goal_data.details.coverImageUrl = require('../../assets/images/default-img.jpg')
        }
      },
      getOneGoal() {
        if (this.goal_data.goals) {
          return this.goal_data.goals[Object.keys(this.goal_data.goals)[0]]
        } else {
          return null
        }
      },
    },
    watch: {
      '$route.params': {
        immediate: true,
        handler() {
          this.init()
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .cal-img {
    overflow: hidden;
    height: auto;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .cal-date {
    position: relative;
    z-index: 1;
  }
  .number-wrapper {
    width: 58px;
    height: 58px;
    background-color: #eef1ff;
    font-size: 20px;
    font-weight: 600;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
  }
  .new-users {
    .media {
      cursor: pointer;
    }
  }
  .list-milestones {
    cursor: pointer;
    border-top: 1px solid #edf1ff;

    h6 {
      font-weight: 600;
      color: #02a9f7;
    }
  }

  .add-first-goal {

    &>.w-100 {
      justify-content: center;
    }

    .add-goal {
      font-size: 20px;
      cursor: pointer;
      user-select: none;
    }
  }
</style>
